import { EpimsBaseEntityDto } from './epim-base.dto';



export class ApprovalLevelDto extends EpimsBaseEntityDto {
  LevelName: string;
  LevelPriority: Number;
}
